import { render, staticRenderFns } from "./Commercialisation.vue?vue&type=template&id=2847db82&"
import script from "./Commercialisation.vue?vue&type=script&lang=js&"
export * from "./Commercialisation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports